/**
 * Created by Allan on 2023/08/09.
 * Contact 84880528@qq.com.
 * 秘鲁还款页面
 */
export default[
	//订单首页
	{
		path:'/app/peruorder/index',
		name:'peruorder',
		meta:{
			title:'Detalles del pedido',
		},
		component: resolve => require(['@/repayment/views/order/peruOrder/index.vue'], resolve)
	},
	//订单详情
	{
		path:'/app/peruorder/history/list/details/:orderId',
		name:'orderDetails',
		meta:{
			title:'Detalles del pedido',
		},
		component: resolve => require(['@/repayment/views/order/peruLoanOrder/index.vue'], resolve)
	},
]



// WEBPACK FOOTER //
// ./src/repayment/router/map/peruorder.js